<template>
    <div class="bg-white shadow px-4 py-5 sm:rounded-lg sm:p-6 mt-4">
        <div class="p-3">

            <slot></slot>

        </div>
    </div>
</template>

<script>
export default {
    name: "ModalContent",
};
</script>

<style scoped>

</style>
